module.exports = __webpack_public_path__ + "static/media/front-image2.c53ed29d.svg";